const API_BASE_URL = 'https://hermes.piramide.tv';

export default API_BASE_URL;
